import {
  CardCvcElement,
  CardExpiryElement,
  CardNumberElement,
  useElements,
  useStripe,
} from '@stripe/react-stripe-js';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import useAxios
 from '../../../axios/useAxios';
import { getCardInfo } from '../../../actions/userCbActions';
import HeaderCart from '../../../components/HeaderCart';
import addpaymentSvg from '../../../styles/img/addpayment.svg';
import { useNavigate } from 'react-router-dom/dist';
import { useEffect } from 'react';
import Swal from 'sweetalert2';
import BackButton from '../../../components/button/BackButton';
import PrimaryButton from '../../../components/button/PrimaryButton';
import { ADD_PAYMENT } from '../../../constants/routes';
const AddCb = () => {
  const dispatch = useDispatch();
  const stripe = useStripe();
  const elements = useElements();
  const axiosInstance = useAxios();
  const user = useSelector((state) => state.user);
  const creditCard = useSelector((state) => state.user.creditCard) || {};
  const navigate = useNavigate();
  const [userName, setUserName] = useState(
    `${user.nom ?? ''} ${user.prenom ?? ''}`,
  );
  const [cardNbComplete, setCardNbComplete] = useState(false);
  const [cardExpComplete, setCardExpComplete] = useState(false);
  const [cardCVCComplete, setCardCVCComplete] = useState(false);
  const [paymentErrorMessage, setPaymentErrorMessage] = useState('');

  const [totalcomplete, setTotalComplete] = useState(false);
  const [focusedElement, setFocusedElement] = useState(null);
  const handleFocus = (element) => {
    setFocusedElement(element);
  };
  const inputStyle = {
    color: 'rgba(0, 0, 0, 1)',
    '::placeholder': {
      color: 'rgba(0, 0, 0, 0.5)',
      fontSize: '12px',
    },
  };

  useEffect(() => {
    if (elements && elements.getElement(CardNumberElement)) {
      elements.getElement(CardNumberElement).on('change', function (event) {
        const { complete } = event;
        if (complete) {
          setCardNbComplete(true);
        } else {
          setCardNbComplete(false);
        }
      });
      elements.getElement(CardExpiryElement).on('change', function (event) {
        const { complete } = event;
        if (complete) {
          setCardExpComplete(true);
        } else {
          setCardExpComplete(false);
        }
      });
      elements.getElement(CardCvcElement).on('change', function (event) {
        const { complete } = event;
        if (complete) {
          setCardCVCComplete(true);
        } else {
          setCardCVCComplete(false);
        }
      });

      elements.getElement(CardNumberElement).on('focus', function (event) {
        setFocusedElement(true);
      });
      elements.getElement(CardExpiryElement).on('focus', function (event) {
        setFocusedElement(true);
      });
      elements.getElement(CardCvcElement).on('focus', function (event) {
        setFocusedElement(true);
      });
      elements.getElement(CardNumberElement).on('blur', function (event) {
        setFocusedElement(false);
      });
      elements.getElement(CardExpiryElement).on('blur', function (event) {
        setFocusedElement(false);
      });
      elements.getElement(CardCvcElement).on('blur', function (event) {
        setFocusedElement(false);
      });
      //setFormCompletion(tempForm);
      //formComplete(tempForm);
    }
  }, [elements, creditCard]);

  useEffect(() => {
    if (cardNbComplete) {
      const expiryElement = elements.getElement(CardExpiryElement);
      if (expiryElement) {
        expiryElement.focus();
      }
    }
    if (cardExpComplete) {
      const cvcElement = elements.getElement(CardCvcElement);
      if (cvcElement) {
        cvcElement.focus();
      }
    }
    // if(cardCVCComplete){
    //   console.log('hello world')
    //   const nameElement = document.getElementById('nomprenom')
    //   if(nameElement){
    //     nameElement.focus()
    //     console.log('focus on name')
    //   }
    // }
  }, [cardNbComplete, cardExpComplete, elements]);
  function countWords(str) {
    return str.split(/\s+/).filter(function (word) {
      return word.length > 0;
    }).length;
  }
  const handleInputChange = (e) => {
    setUserName(e.target.value);
  };

  const handleAddCard = async () => {
    if (
      countWords(userName) > 1 &&
      cardNbComplete &&
      cardExpComplete &&
      cardCVCComplete
    ) {
      const cardElement = elements.getElement(CardNumberElement);
      const data = await stripe.createPaymentMethod({
        type: 'card',
        card: cardElement,
        billing_details: {
          name: userName,
          email: user.email,
        },
      });
      user.fullName = userName;
      await dispatch(
        getCardInfo(
          data.paymentMethod.id,
          user,
          axiosInstance,
          setPaymentErrorMessage,
        ),
      );
    } else {
      Swal.fire({
        title: 'Oups, il manque les info de carte',
        icon: 'warning',
        confirmButtonText: `Ok`,
        buttonsStyling: false,
        customClass: {
          confirmButton:
            'w-[100px] h-[40px] bg-[#FF0000] rounded-[10px] text-white geomanistBold text-[1.4rem] p-4',
        },
      });
    }
  };

  useEffect(() => {
    if (user.error) {
      Swal.fire({
        title: 'Pense à bien vérifier les infos saisies !',
        icon: 'warning',
        confirmButtonText: `Ok`,
        buttonsStyling: false,
        customClass: {
          confirmButton:
            'w-[100px] h-[40px] bg-[#FF0000] rounded-[10px] text-white geomanistBold text-[1.4rem] p-4',
        },
      });
    } else if (user.creditCard && user.creditCard[0] && user.creditCard[0].pm) {
      navigate('/account/wallet', { state: { prevPage: 'addCb' } });
      Swal.fire({
        title: 'Carte enregistrée avec succès',
        icon: 'success',
        confirmButtonText: `Ok`,
        buttonsStyling: false,
        customClass: {
          confirmButton:
            'w-[100px] h-[40px] payer rounded-[10px] text-white geomanistBold text-[1.4rem] p-4',
        },
      });
    }
  }, [user]);

  return (
    <>
      {user.loading ? (
        <div
          className="absolute z-50 w-screen h-screen bg-black bg-opacity-50"
          // style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
        >
          <div className="z-50 absolute left-2/4 top-[25%]  -translate-x-2/4 ">
            <div className="lds-spinner white">
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
            </div>
          </div>
        </div>
      ) : (
        <></>
      )}
      {!user.creditCard || !user.creditCard[0] || !user.creditCard[0].pm ? (
        <>
          <div className="global-header">
            <BackButton onClick={() => navigate(ADD_PAYMENT)} />
            <HeaderCart titre="Ajouter une carte" />
          </div>
          <div className="flex flex-col w-full gap-6 p-8 pb-40">
            <div className="flex-col flex w-full gap-6 gap-2 ">
              <div className="flex flex-col w-full">
                <label
                  className="text-[1.7rem] geomanistMedium w-full flex justify-between "
                  htmlFor="cardId"
                >
                  Numéro de carte
                  <div className="flex cbimg no-wrap">
                    <img
                      className="h-10 rounded-[5px]"
                      src="https://firebasestorage.googleapis.com/v0/b/gensheet-b606a.appspot.com/o/Amex.png?alt=media&token=ddb2a999-aaf8-47a0-91e6-7346a0242214"
                    />
                    <img
                      className="h-10"
                      src="https://firebasestorage.googleapis.com/v0/b/gensheet-b606a.appspot.com/o/Visa.png?alt=media&token=56967d89-2fc1-490e-94a4-631810baca52"
                    />
                    <img
                      className="h-10"
                      src="https://firebasestorage.googleapis.com/v0/b/gensheet-b606a.appspot.com/o/Mastercard.png?alt=media&token=4448318a-223e-4511-aa96-410b5da62144"
                    />
                  </div>
                </label>
                <div className="w-full border-solid rounded-[0.8em] geomanistBold border-[1px] border-[#3b3b3b5a] p-4 h-18 items-center">
                  <CardNumberElement
                    id="cardId"
                    options={{ style: { base: inputStyle } }}
                    onFocus={() => handleFocus(1)}
                  />
                </div>
              </div>

              <div className="flex justify-between w-full gap-6">
                <div className="flex flex-col w-full gap-2">
                  <label
                    className="text-[1.5rem] geomanistMedium"
                    htmlFor="expiryId"
                  >
                    Date d'exp.
                  </label>
                  <div className="w-full border-solid rounded-[0.8em] geomanistBold border-[1px] border-[#3b3b3b5a] p-4 h-18 items-center">
                    <CardExpiryElement
                      id="expiryId"
                      options={{ style: { base: inputStyle } }}
                      onFocus={() => handleFocus(2)}
                    />
                  </div>
                </div>

                <div className="flex flex-col w-full gap-2">
                  <label
                    className="text-[1.5rem] geomanistMedium"
                    htmlFor="ccv"
                  >
                    Crypto
                  </label>
                  <div className="w-full border-solid rounded-[0.8em] geomanistBold border-[1px] border-[#3b3b3b5a] p-4 h-18 items-center ">
                    <CardCvcElement
                      id="ccv"
                      options={{ style: { base: inputStyle } }}
                      onFocus={() => handleFocus(3)}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="flex flex-col w-full gap-2">
              <label
                className="text-[1.5rem] geomanistMedium"
                htmlFor="nomprenom"
              >
                Nom et prénom sur la carte
              </label>
              <div className="w-full pl-4 border-solid rounded-[0.8em]  border-[1px] border-[#3b3b3b5a] h-18 items-center overflow-hidden">
                <input
                  className=" interMedium text-[14px] w-full"
                  placeholder="Nom et prénom sur la carte"
                  maxLength="20"
                  type="text"
                  required
                  name="name"
                  id="nomprenom"
                  value={userName === ' ' ? '' : userName}
                  onChange={handleInputChange}
                  autoComplete="name"
                />
              </div>
            </div>
            <div className="w-full border-solid border-[1px] flex flex-col border-[#3b3b3b5a] rounded-[10px] gap-2  p-4">
              <div
                style={{
                  fontFamily: 'geomanistmedium',
                  fontWeight: 'bold',
                  fontSize: '12px',
                }}
              >
                Enregistrer ma carte pour les prochaines fois
              </div>
              <div>
                Nous accordons une grande importance à ta vie privée. C'est
                pourquoi nous ne conservons aucune informations sans avoir un
                accord au préalable.
              </div>
            </div>
            {paymentErrorMessage && (
              <div className="payment-error no-bottom">
                {paymentErrorMessage}
              </div>
            )}
            <PrimaryButton
              onClick={handleAddCard}
              label="Ajouter"
              icon={addpaymentSvg}
            />
          </div>
        </>
      ) : (
        <></>
      )}
    </>
  );
};

export default AddCb;
